import { ComponentPublicInstance, onUnmounted, ref } from 'vue';

export function useIntersectionOnce(options?: IntersectionObserverInit) {
  const isVisible = ref(false);
  let observer: IntersectionObserver | undefined;

  const setRef = (el: Element | ComponentPublicInstance | null) => {
    observer?.disconnect();
    if (!el || isVisible.value) return;
    if (!(el instanceof Element)) {
      if (!(el.$el instanceof Element)) return;
      el = el.$el;
    }

    observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        isVisible.value = true;
        observer?.disconnect();
      }
    }, options);
    observer.observe(el);
  };

  onUnmounted(() => observer?.disconnect());

  return { isVisible, setRef };
}
